<script setup lang="ts">
import axios from 'axios';
import { computed, onMounted, ref, watch } from 'vue';

const numberFormat = new Intl.NumberFormat('sv-SE', { style: 'percent' });
const props = defineProps<{
    userId?: number | null;
    days: number;
}>();

const hitRate = ref<number | undefined>(undefined);
const hitRateFormatted = computed(() => hitRate.value === undefined ? undefined : numberFormat.format(hitRate.value));

async function loadData(): Promise<void> {
    const response = await axios.get('/stats/hit_rate', { params: { user_id: props.userId ?? null, days: props.days } });
    hitRate.value = response.data.hit_rate;
}

onMounted(loadData);
watch(() => [props.userId, props.days], loadData);
</script>

<template>
    <div>
        <p v-if="hitRate !== undefined">{{ hitRateFormatted }}</p>
        <div v-else class="spinner-border" role="status"><span class="sr-only">Laddar</span></div>
    </div>
</template>

<style scoped>
p { font-size: 1.5em; }
</style>
